
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js'

import AppCarousel from '../AppCarousel.vue'
import time from '@/components/tools/time'
import CountDown from '@/components/catalog/product/CountDown'

export default {
  mdiArrowRight,
  mdiArrowLeft,
  carouselOptions: {
    preloadImages: false
  },
  components: { CountDown, AppCarousel },
  props: {
    products: {
      type: Array,
      default: () => []
    },
    hideAuctionCountDown: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    centered: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    endingAt (product) {
      return time.parseDate(product.auction.endingAt)
    },
    startingAt (product) {
      return time.parseDate(product.auction.startingAt)
    }
  }
}
